export const removeNameSeparator = (input: string): string => {
    return input.replace(/_/g, " ");
};